/** @file signedDegrees: an angle in degrees wrapped into [-180, 180), as the angle fields show it. */
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/** `deg` wrapped into [-180, 180) (200 becomes -160). */
export function signedDegrees(deg: number): number {
  return wrapDegrees(deg + 180) - 180;
}
